<template>
  <div class="maintitle">
    <span>{{title}}</span>
  </div>
</template>

<script>
export default {
    name: 'EXMainTitle',
    props:{
        title: String
    }
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';
.maintitle {
  width: 100%;
  display: flex;
  align-items: center;
  span {
    display: inline-block;
    width: 14%;
    text-align: center;
    color: #2153c0;
    @include font_color($font-colorD);
    font-weight: bold;
    font-size: 0.2rem;
  }
  &::before {
    content: "";
    display: inline-block;
    width: 43%;
    @include font_bg($font-bgD);
    height: 0.02rem;
  }
  &::after {
    content: "";
    display: inline-block;
    width: 43%;
    @include font_bg($font-bgD);
    height: 0.02rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/EXArticle/mainTitle.vue